import api from './api-service';

const PersonalAccessTokenService = {
	list() {
		return api.client.get('/personal-access-tokens', { headers: { 'X-Range': 'resources=0-200' } }).then((res) => res.data);
	},

	create({ name, expiresAt }) {
		return api.client.post('/personal-access-tokens', { name, expiresAt }).then((res) => res.data);
	},

	revoke(id) {
		return api.client.delete(`/personal-access-tokens/${id}`);
	}
};

export default PersonalAccessTokenService;
